var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProcessArrowShape(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 21,
    viewBox: "0 0 86 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Arrow 05",
    clipPath: "url(#clip0_24_10052)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Arrow 05_2",
    d: "M6.7277e-06 20.6284C3.80666 12.8891 24.1293 2.59028 38.6191 0.76209C54.2755 -1.24891 63.301 0.457393 81.7203 9.04987C81.4747 7.83108 81.1677 6.85605 81.0449 5.94196C80.8607 4.90598 80.6765 3.80907 80.7379 2.7731C80.7379 2.4684 81.2905 1.91994 81.6589 1.859C82.0273 1.79806 82.6413 2.22464 82.7641 2.52934C83.8692 5.45444 84.8516 8.37954 85.8953 11.3656C86.2023 12.3406 85.8339 13.0719 84.7902 13.3766C80.7993 14.3516 76.8085 15.3876 72.7562 16.3017C71.8353 16.4845 70.7301 16.2407 69.5022 16.2407C70.4845 13.6203 72.6949 13.925 74.2912 13.2547C75.9489 12.5234 77.7295 12.0969 79.8784 11.3656C74.7824 7.95296 69.625 5.82008 64.1606 4.4794C44.1449 -0.51764 25.7256 3.62625 8.71848 14.7172C6.50816 16.1798 4.48205 17.8861 2.33313 19.4096C1.65775 19.7143 1.04376 20.019 6.7277e-06 20.6284Z",
    fill: "#FF7236"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24_10052"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 86,
    height: 20.6284,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcessArrowShape);
export default __webpack_public_path__ + "static/media/process-arrow-shape.cde10e4468a5d74e50176566a37f8273.svg";
export { ForwardRef as ReactComponent };